import {
  SET_SELECTED_BONUS_SKUS,
  CLEAR_SELECTED_BONUS_SKUS,
  SET_AVAILABLE_BONUS_SKUS,
  SET_AS_OF_DATE,
} from './actions'

const initialState = {
  selectedBonusSkus: [],
  availableBonusSkus: [],
  asOfDate: null,
}

export default function bonusSkuReducer (state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_BONUS_SKUS:
      return {
        ...state,
        selectedBonusSkus: action.payload,
      }
    case CLEAR_SELECTED_BONUS_SKUS:
      return {
        ...state,
        selectedBonusSkus: [],
      }
    case SET_AVAILABLE_BONUS_SKUS:
      return {
        ...state,
        availableBonusSkus: action.payload,
      }
    case SET_AS_OF_DATE:
      return {
        ...state,
        asOfDate: action.payload,
      }
    default:
      return state
  }
}

export { initialState }
